import * as fromStorage from '@iw-shared/store/reducers/storage.reducer';
import * as fromAuthentication from '@iw-shared/store/reducers/authentication.reducers';
import * as fromApp from '@iw-shared/store/reducers/global.reducer';
import * as fromUser from '@iw-shared/store/reducers/user.reducer';
import * as fromWindows from '@iw-shared/store/reducers/windows.reducer';
import * as fromChangeDetection from '@iw-shared/store/reducers/change-detection.reducers';
import * as fromConfig from '@account/store/reducers/config.reducer';

export const appReducers = {
  storage: fromStorage.reducer,
  global: fromApp.reducer,
  authentication: fromAuthentication.reducer,
  user: fromUser.reducer,
  windows: fromWindows.reducer,
  changeDetection: fromChangeDetection.reducer,
  config: fromConfig.reducer
};

